import { useQuery } from '@based'
import { createContext, useContext } from 'react'
import { useLanguage } from './hooks/useLanguage.js'
export type AppCtxProps = {
  content: 'content' | 'preview'
  sequence?: number
  contestant?: number
  lang?: string
  activeLanguage?: string
  votesCount?: number
  minVotes?: number
  maxVotes?: number
  price?: number
  currency?: string
}
export const AppCtx = createContext<AppCtxProps>({
  content: 'content',
})

export const useAppCtx = () => useContext(AppCtx)

export const useContentQuery = (
  endpoint:
    | 'preview'
    | 'sequence'
    | 'dictionary'
    | 'onboarding'
    | 'privacy'
    | 'info'
    | 'terms'
    | 'votingRegion'
    | 'lyrics'
    | 'winner'
    | 'announcement'
    | null,
  payload?: any,
  persistent: boolean = false,
) => {
  const ctx = useAppCtx()
  const [{ code }] = useLanguage()
  const args = [endpoint, code, payload]
  const res = useQuery(
    // @ts-ignore
    endpoint && ctx.content,
    args,
    {
      persistent,
    },
  )
  return res
}
